import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SiteService } from '../site/site.service';
import { UserManagementService } from '../user-management/user-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NotificationsService } from '../notifications/notifications.service';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {
  buildNavbarMenuItems,
  buildNavbarNotificationConfig,
  buildProfileMenuItems,
  NavbarMenuItem,
  NavbarNotificationConfig,
} from '../shared-navbar/navbar-config';
import { executeNavbarAction } from '../shared-navbar/navbar-actions';

@Component({
    selector: 'app-site-admin-nav',
    templateUrl: './site-admin-nav.component.html',
    styleUrls: ['./site-admin-nav.component.css'],
    standalone: false
})
export class SiteAdminNavComponent implements OnInit, OnDestroy {
  private storage = environment.storage;
  @ViewChild('content') content;
  @ViewChild('picker') picker: any;
  @ViewChild('notificationListComponent') notificationListComponent: any;
  @ViewChild('siteEditStatusDialog') siteEditStatusDialog: any;
  public dateRange: any;
  public isCollapsed = false;
  public isMenuCollapsed = true;
  public user: any;
  allocatedSite:any;
  public siteinfo:any;
  pdfurl:any;
  sitename:any;
  periodicDateRange : any;
  modelref : any;
  data: any;
  loading = 0;
  visitedUserManagementSites = false;
  unreadNotificationCount = 0;
  isNotificationPanelOpen = false;
  private subscriptions: Subscription[] = [];
  avatarUrl: string = './assets/images/avathar.jpg';
  imageSrc: SafeUrl | string = this.avatarUrl;
  constructor( 
    private router: Router,
    private userService: UserManagementService,
    private siteService: SiteService,
    private modalService: NgbModal,
    private notificationService: NotificationsService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const allSites = this.userService.getSiteDetail();
    this.user = this.userService.getUserDetail();
    this.siteinfo=this.userService.getSiteDetail();
    if(allSites?.length){
      this.allocatedSite = allSites[0].site_id;
      this.pdfurl = this.siteService.getPDFUrl(this.siteinfo[0].sitepfd);
      this.sitename=this.siteinfo[0].site_name;
    }
    if (this.user?.id || this.user?.user_id) {
      this.loadUserImage(this.user.id || this.user.user_id);
    } else {
      this.imageSrc = this.avatarUrl;
    }
     this.visitedUserManagementSites = sessionStorage.getItem('visitedUserManagementSites') === 'true';
     
  }

  loadUserImage(userId: string | number): void {
    if (!userId) {
      this.imageSrc = this.avatarUrl;
      return;
    }
    const imageUrl = `${environment.nodeUrl1}user-image/${userId}?t=${Date.now()}`;
    this.http.get(imageUrl, { responseType: 'blob' }).subscribe(
      (blob) => {
        this.imageSrc = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(blob)
        );
      },
      () => {
        this.imageSrc = this.avatarUrl;
      }
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private clearAllFilterSelections(): void {
    try {
      const allKeys = Object.keys(localStorage);
      const filterKeys = allKeys.filter(key => key.startsWith('reportFilter_'));
      
      filterKeys.forEach(key => {
        localStorage.removeItem(key);
        console.log(`✅ Site Admin Nav: Cleared filter selection for key: ${key}`);
      });
      
      console.log(`🎉 Site Admin Nav: Cleared ${filterKeys.length} filter selections`);
    } catch (e) {
      console.error('❌ Error clearing filter selections in site-admin-nav:', e);
    }
  }

  navigateToHome(modal: any): void {
    modal.close();
    this.router.navigate(['/']);
  }

  toggleNotificationPanel(): void {
    this.isNotificationPanelOpen = !this.isNotificationPanelOpen;
    // Prevent body scroll when panel is open
    if (this.isNotificationPanelOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closeNotificationPanel(): void {
    this.isNotificationPanelOpen = false;
    document.body.style.overflow = '';
  }

  onBackdropClick(event: MouseEvent): void {
    // Close panel when clicking on backdrop
    if ((event.target as HTMLElement).classList.contains('notification-backdrop')) {
      this.closeNotificationPanel();
    }
  }

  get notificationConfig(): NavbarNotificationConfig {
    return buildNavbarNotificationConfig('site-admin', {
      userRole: this.user?.role ?? this.user?.user_role,
    });
  }

  get menuItems(): NavbarMenuItem[] {
    return buildNavbarMenuItems('site-admin', {
      userRole: this.user?.role ?? this.user?.user_role,
      hasPfd: !!this.siteinfo?.[0]?.sitepfd,
    });
  }

  get profileMenuItems(): NavbarMenuItem[] {
    return buildProfileMenuItems('site-admin', {
      visitedUserManagementSites: this.visitedUserManagementSites,
    });
  }

  onNavbarAction(actionId: string): void {
    void executeNavbarAction(actionId, {
      router: this.router,
      userService: this.userService,
      clearFilterSelections: () => this.clearAllFilterSelections(),
      allocatedSite: this.allocatedSite,
      user: this.user,
      http: this.http,
      modalService: this.modalService,
      siteEditStatusDialog: this.siteEditStatusDialog,
    });
  }

}
